import { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

export default function SsoFinish() {
  const { setTokenAndLoad } = useAuth();
  const navigate = useNavigate();
  const [params] = useSearchParams();

  useEffect(() => {
    const token = params.get('token');
    const returnTo = params.get('return_to') || '/';
    if (!token) {
      navigate('/login?error=sso_failed', { replace: true });
      return;
    }
    setTokenAndLoad(token)
      .then(() => navigate(returnTo, { replace: true }))
      .catch(() => navigate('/login?error=sso_failed', { replace: true }));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div style={{
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      minHeight: '100vh',
      fontFamily: 'sans-serif',
      color: '#555',
    }}>
      Signing you in…
    </div>
  );
}
